import Environments, { Brands } from '@delta-defense/client-environments';

enum SourcesForAuth {
	USCCA = 'uscca',
	CabelasShield = 'cabelas_shield'
}

const sourcesForAuthByBrand: Record<Brands, SourcesForAuth> = {
  [Brands.USCCA]: SourcesForAuth.USCCA,
  [Brands.CabelasShield]: SourcesForAuth.CabelasShield
};

export const getSourceForAuthApi = (getDomainBrandFunc = Environments.getDomainBrand): SourcesForAuth => {
  return sourcesForAuthByBrand[getDomainBrandFunc()];
};
